function doMeatLocations() {
  if (customElements.get("meat-locations")) return null;

  class MeatLocations extends HTMLElement {
    constructor() {
      super();
      this.script = this.querySelector('script[type="application/json"]');
      this.animalTabs = this.querySelectorAll(".meatLocation-animalTabs li");
      this.mapImageParent = this.querySelector(".inner-col1 .map-image");
      this.mapImageWrapper = this.querySelector(".col1 .map-image-wrapper");
      this.lifestyleWrapper = this.querySelector(
        ".inner-col1 .regionLifestyleImage-wrapper"
      );
      this.featuredImageWrapper = this.querySelector(
        ".col1 .animal-featured-images"
      );
      if (this.script == null) return null;
      this.scriptAnimalArticles = JSON.parse(this.script.textContent);

      this.init();
    }

    init() {
      const { animalLocationArticles } = this.scriptAnimalArticles;
      if (animalLocationArticles == null) return null;

      animalLocationArticles.forEach((animalArticle, index) => {
        this.appendAnimalAccordion(animalArticle, index === 0 && true);
        this.appendAnimalCarousel(animalArticle, index === 0 && true);
      });

      this.handleAnimalTabs();
    }

    /**
     * Executes after getting articles data
     */
    initAfterLoad() {
      $(window).on("load", () => {});
    }

    makeFetchUrl() {
      const url = new URL(window.location.href);
      const firstSegment = url.pathname.split("/")[1];

      // eg. ja-jp or zz-pp
      const regex = /^[a-z]{2}-[a-z]{2}$/;
      const isValidFormat = regex.test(firstSegment);

      return isValidFormat ? `/${firstSegment}/blogs/` : `/blogs/`;
    }

    /**
     * Fetches an article's section element with the class name ".general-accordion-wrapper"
     * Followed by appending it to .meatLocation-accordion
     * @param {String} articleHandle
     * @param {Boolean} isFirst
     */
    appendAnimalAccordion(articleHandle, isFirst) {
      const dataAttr = isFirst
        ? `data-is-first data-status="1"`
        : `data-status="0"`;
      $(".meatLocation-accordion").append(
        $(
          `<div class="location-accordion-wrapper" data-handle="${articleHandle}" ${dataAttr} data-ml-content>`
        ).load(
          `${this.makeFetchUrl()}${articleHandle} .general-accordion-wrapper`,
          () => {
            this.handleAccordion();
          }
        )
      );
    }

    /**
     * Fetches an article's section element with the class name ".meatLocations-carousel"
     * Followed by appending it to .meatLocation-accordion
     * The swiper gets executed after the load
     * @param {String} articleHandle
     * @param {Boolean} isFirst
     */
    appendAnimalCarousel(articleHandle, isFirst) {
      const dataAttr = isFirst
        ? `data-is-first data-status="1"`
        : `data-status="0"`;
      $(".meatLocation-mob-carousel").append(
        $(
          `<div data-handle="${articleHandle}" ${dataAttr} class="ml-mob-carousel-loaded" data-ml-content>`
        ).load(
          `${this.makeFetchUrl()}${articleHandle} .meatLocations-carousel`,
          () => {
            const swiper = new Swiper(".meatLocations-carousel-swiper", {
              slidesPerView: "auto",
              spaceBetween: 20,
              cssMode: true,
              centeredSlides: true,
            });
          }
        )
      );
    }

    handleAnimalTabs() {
      if (this.animalTabs == null) return null;

      this.animalTabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const tabHandle = tab.dataset.handle;
          this.disableAllAnimalTabs();
          tab.setAttribute("data-status", 1);
          this.hideShowContent(tabHandle);
          this.lifestyleWrapper.setAttribute("data-status", 0);
          this.featuredImageWrapper.setAttribute("data-status", 1);
          this.mapImageParent.setAttribute("data-status", 0);
        });
      });
    }

    disableAllAnimalTabs() {
      this.animalTabs.forEach((tab) => tab.setAttribute("data-status", 0));
    }

    /**
     * hideShow main image, accordion, carousel
     * @param {String} articleHandle
     */
    hideShowContent(articleHandle) {
      const allContent = this.querySelectorAll("[data-ml-content]");

      allContent.forEach((content) => {
        if (content.dataset.handle == articleHandle) {
          content.setAttribute("data-status", 1);
          return;
        }

        content.setAttribute("data-status", 0);
      });
    }

    handleAccordion() {
      const allAccordions = this.querySelectorAll(".snippet-generalAccordion");

      allAccordions.forEach((accordion) => {
        const accordionHeader = accordion.querySelector(
          ".generalAccordion-header"
        );
        const articleMapImage = accordion.querySelector(
          ".meatRegion-img-wrapper img"
        );
        const articleLifestyleImage = accordion.querySelector(
          ".meatRegion-imgLifeStyle-wrapper img"
        );

        accordionHeader.addEventListener("click", () => {
          if (accordion.dataset.status != "0") {
            if (articleMapImage != null) {
              this.mapImageWrapper.innerHTML = "";
              this.mapImageParent.setAttribute("data-status", 1);
              this.mapImageWrapper.append(articleMapImage);
            }

            if (articleLifestyleImage != null) {
              this.lifestyleWrapper.innerHTML = "";
              this.lifestyleWrapper.append(articleLifestyleImage);
              this.featuredImageWrapper.setAttribute("data-status", 0);
              this.lifestyleWrapper.setAttribute("data-status", 1);
            }
          }
        });
      });

      // setTimeout(() => {
      //   this.querySelector(
      //     ".meatLocation-accordion [data-is-first] .generalAccordion-header"
      //   ).click();
      // }, 300);
    }
  }

  customElements.define("meat-locations", MeatLocations);
}

doMeatLocations();
